import { CCardFooter } from "@coreui/react";
import { AttachFile, Delete } from "@mui/icons-material";
import { Box, Button, Card, CardContent, CardHeader, Divider, IconButton, Select, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { T_Error } from "../../common/model/errorModel";
import { useState } from "react";
import { initialAlert, useAlert } from "../../provider/AlertContextProvider";
import apis from "../../common/apis";
import { T_Param } from "../../common/model/paramModle";

export default function ParamEdit(){
  const { state } = useLocation();
    // state.inqueryData 에서 넘어온 item 객체를 꺼낼 수 있습니다.
    const item = state?.item;

    const [data,setData] = useState<T_Param>(item)
    const nav = useNavigate();
    const {alert,setAlert} = useAlert();
    const saveData = async()=>{
            
        if(data.param === "" || data.param === undefined){
            setAlert({...alert,visible:true,title:"확인",msg:"파라미터를 입력하여 주십시요"})   
            return;
        }
        if(data.name == "" || data.name === undefined){
            setAlert({...alert,visible:true,title:"확인",msg:"명칭을 입력하여 주십시요"})   
            return;
        }
         
        setAlert({...alert,title:"확인",msg:"정말로 수정 하시겠습니가?",visible:true,buttonList:[
            {
                text:"예"
                ,variant:"contained"
                ,onPress:async()=>{
                    const result = await apis.param.paramUpdate(data);
                    console.log("result:",result);
                    if(result.code=="1"){
                        setAlert(initialAlert);
                        setAlert({...alert,visible:true,title:"확인",msg:"수정이 완료되었습니다."});
                        nav("/param")
                    }else{
                        setAlert(initialAlert);
                        setAlert({...alert,visible:true,title:"확인",msg:"수정중 오류가 발생했습니다.."})
                    }
           
                }
            },{
                text:"아니요"
                ,variant:"outlined"
                ,onPress:()=>{
                    setAlert(initialAlert);
                }
            }
        ]})
    }
    return(
        <>
         <Card >
        <CardHeader title="파라미터정보 등록" sx={{pb:0,mb:0}}/>
        <CardContent>
            <Divider />
        <Table  stickyHeader aria-label="sticky table"  sx={{borderTopWidth:2
          }} > 
            <TableHead />
            <TableBody>
            <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          파라미터
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                          <TextField  size="small" fullWidth value={data.param || ''} onChange={(event)=>{setData({...data,param:event.target.value})}} />
                        </TableCell>      

        </TableRow>        

        <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          명칭
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                          <TextField 
                          size="small"
                            fullWidth 
                            value={data.name || ''} onChange={(event)=>{setData({...data,name:event.target.value})}}
                          />
                        </TableCell>      

        </TableRow>          
        <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          출고설정
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                          <TextField 
                          size="small"
                            fullWidth 
                            value={data.base || ''} onChange={(event)=>{setData({...data,base:event.target.value})}}
                          />
                        </TableCell>      

        </TableRow>          
        <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          현장조정값
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                          <TextField 
                          size="small"
                            fullWidth 
                            value={data.limi || ''} onChange={(event)=>{setData({...data,limi:event.target.value})}}
                          />
                        </TableCell>      

        </TableRow>          

        <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          내용
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                          <TextField multiline
                            rows={10}
                            fullWidth 
                            value={data.content || ''} onChange={(event)=>{setData({...data,content:event.target.value})}}
                          />
                        </TableCell>      

        </TableRow>          

     
     
        </TableBody>

        </Table>

        </CardContent>
        <CCardFooter style={{   display: 'flex',justifyContent:'center',textAlign:'center',paddingBottom:10, gap: '1rem'}}  >
        <Button variant="contained" onClick={()=>{
            saveData();
        }}>수정</Button>
        <Button variant="outlined" onClick={()=>{
                nav(-1);
            }}>취소</Button>

        </CCardFooter>
    </Card>
        </>
    )
}